import { createStore, forward } from "effector";
import { connected, disconnected, sendJoinCollaboration } from "./events";

export const $isConnected = createStore(false)
  .on(connected, () => true)
  .on(disconnected, () => false);

forward({ from: connected, to: sendJoinCollaboration });
